import { GeneratedFileType } from '@doss/prisma/types'
import { AbaReportInspectionFileData } from './aba-report-inspection.js'
import { ArkFoodsBillOfLadingFileData } from './ark-foods-bill-of-lading.js'
import { ArkFoodsInvoiceFileData } from './ark-foods-invoice.js'
import { ArkFoodsOrderConfirmationFileData } from './ark-foods-order-confirmation.js'
import { ArkFoodsPassingSheetFileData } from './ark-foods-passing-sheet.js'
import { ArkFoodsPurchaseOrderFileData } from './ark-foods-purchase-order.js'
import { ArkFoodsQcInspectionFileData } from './ark-foods-qc-inspection.js'
import { ArkFoodsTraderJoesPackingSlipFileData } from './ark-foods-trader-joes-packing-slip.js'
import { AthenaClubBomExportXlsxFileData } from './athena-club-bom-export-xlsx.js'
import { AthenaClubCoManEomInventoryReconciliationXlsxFileData } from './athena-club-co-man-eom-inventory-reconciliation-xlsx.js'
import { AthenaClubPurchaseOrderFileData } from './athena-club-purchase-order.js'
import { BalanceSheetSinglePeriodXlsxFileData } from './balance-sheet-single-period-xlsx.js'
import { BalanceSheetFileData } from './balance-sheet.js'
import { BillingStatementFileData } from './billing-statement.js'
import { BiomGenericGs1128LabelFileData } from './biom-generic-gs1-128-label.js'
import { BiomGenericPackingListFileData } from './biom-generic-packing-list.js'
import { BiomGroveCasePackLabelFileData } from './biom-grove-case-pack-label.js'
import { BiomGroveMultiSkuPalletLabelFileData } from './biom-grove-multi-sku-pallet-label.js'
import { BiomGroveOneSkuPalletLabelFileData } from './biom-grove-one-sku-pallet-label.js'
import { BiomGrovePackingListFileData } from './biom-grove-packing-list.js'
import { BiomTargetPackingListFileData } from './biom-target-packing-list.js'
import { BiomThrivePackingListFileData } from './biom-thrive-packing-list.js'
import { BiomUnfiPackingListFileData } from './biom-unfi-packing-list.js'
import { BiomUnfiPalletPlacardFileData } from './biom-unfi-pallet-placard.js'
import { BiomVicsBillOfLadingFileData } from './biom-vics-bill-of-lading.js'
import { BiomVicsMasterBillOfLadingFileData } from './biom-vics-master-bill-of-lading.js'
import { BiomWarehouseAddressLabelFileData } from './biom-warehouse-address-label.js'
import { BiomWarehousePickingSlipFileData } from './biom-warehouse-picking-slip.js'
import { BNZBriefingFileData } from './bnz-briefing.js'
import { BNZEmployeeSafetyFileData } from './bnz-employee-safety.js'
import { BNZProjectSubmissionFileData } from './bnz-project-submission.js'
import { BNZWorkDiaryFileData } from './bnz-work-diary.js'
import { CaulipuffsCopackPurchaseOrderFileData } from './caulipuffs-copack-purchase-order.js'
import { CaulipuffsInvoiceFileData } from './caulipuffs-invoice.js'
import { CommercialInvoiceFileData } from './commercial-invoice.js'
import { CreditMemoFileData } from './credit-memo.js'
import { CsvFileOutputData } from './csv.js'
import { DeSoiProductInformationWorksheetCanXlsxFileData } from './de-soi-product-information-worksheet-can-xlsx.js'
import { DeSoiPurchaseOrderFileData } from './de-soi-purchase-order.js'
import { DenimTearsPurchaseOrderV2FileData } from './denim-tears-purchase-order-v2.js'
import { DenimTearsPurchaseOrderFileData } from './denim-tears-purchase-order.js'
import { DiversifiedBotanicalsInventoryLabelFileData } from './diversified-botanicals-inventory-label.js'
import { DiversifiedBotanicalsPOFileData } from './diversified-botanicals-purchase-order.js'
import { DiversifiedBotanicalsSalesOrderFileData } from './diversified-botanicals-sales-order.js'
import { DnbPOFileData } from './dnb-purchase-order.js'
import { EightSleepPOBilingualFileData } from './eight-sleep-purchase-order-bilingual.js'
import { EightSleepPORmbFileData } from './eight-sleep-purchase-order-rmb.js'
import { EightSleepPOFileData } from './eight-sleep-purchase-order.js'
import { FactorFormPurchaseOrderFileData } from './factor-form-purchase-order.js'
import { FirstbaseCpReceiptFileData } from './firstbase-cp-receipt.js'
import { FirstbasePoImportFileData } from './firstbase-po-import.js'
import { FirstbaseRequestForQuoteFileData } from './firstbase-request-for-quote.js'
import { GGPurchaseOrderFileDataXlsx } from './gg-purchase-order-xlsx.js'
import { GraceFarmsPackingSlipFileData } from './grace-farms-packing-slip.js'
import { IHPOFileData } from './ih-purchase-order.js'
import { IncomeStatementSinglePeriodXlsxFileData } from './income-statement-single-period-xlsx.js'
import { IncomeStatementXlsxFileData } from './income-statement-xlsx.js'
import { IncomeStatementFileData } from './income-statement.js'
import { InvoiceFileData } from './invoice.js'
import { K1893FreightQuoteFileData } from './k1893-freight-quote.js'
import { K1893InvoiceMeijerFileData } from './k1893-invoice-meijer.js'
import { K1893InvoiceTjsFileData } from './k1893-invoice-tjs.js'
import { K1893InvoiceUnfiFileData } from './k1893-invoice-unfi.js'
import { K1893InvoiceFileData } from './k1893-invoice.js'
import { K1893PalletInstructionsFileData } from './k1893-pallet-instructions.js'
import { K1893PurchaseOrderOVGFileData } from './k1893-purchase-order-ovg.js'
import { K1893PurchaseOrderFileData } from './k1893-purchase-order.js'
import { LittlBeastPurchaseOrderFileData } from './little-beast-purchase-order.js'
import { MagicMindPackingSlipFileData } from './magic-mind-packing-slip.js'
import { MagicMindPurchaseOrderFileData } from './magic-mind-purchase-order.js'
import { MezclaPurchaseOrderFileData } from './mezcla-purchase-order.js'
import { NoodlesComplaintFileData } from './noodles-complaint.js'
import { NoodlesCreditNoteFileData } from './noodles-credit-note.js'
import { NoodlesDeliveryNoteFileData } from './noodles-delivery-note.js'
import { NoodlesInvoiceFileData } from './noodles-invoice.js'
import { NoodlesMidaboSupplierOrderFileData } from './noodles-midabo-supplier-order.js'
import { NoodlesOrderFileData } from './noodles-order.js'
import { NoodlesQuoteFileData } from './noodles-quote.js'
import { NoodlesSupplierOrderFileData } from './noodles-supplier-order.js'
import { PalletLabelFileData } from './pallet-label.js'
import { PavoiCommercialInvoiceFileData } from './pavoi-commercial-invoice.js'
import { PickTicketFileData } from './pick-ticket.js'
import { PopdartsCommissionInvoiceXlsxFileData } from './popdarts-commission-invoice-xlsx.js'
import { POv2FileData } from './purchase-order-v2.js'
import { POv3FileData } from './purchase-order-v3.js'
import { POv4FileData } from './purchase-order-v4.js'
import { PurchaseOrderFileData } from './purchase-order.js'
import { QuoteFileData } from './quote.js'
import { ReflorPurchaseOrderFileData } from './reflor-purchase-order.js'
import { ReflorWorkOrderFileData } from './reflor-work-order.js'
import { RemittanceAdviceFileData } from './remittance-advice.js'
import { SalesOrderFileData } from './sales-order.js'
import { SelkirkPurchaseOrderFileData } from './selkirk-purchase-order.js'
import { SlMunson1099FormFileData } from './sl-munson-1099-form.js'
import { SlMunsonPackingSlipFileData } from './sl-munson-packing-slip.js'
import { SmashFoodsBlanketPOFileData } from './smash-foods-blanket-purchase-order.js'
import { SmashFoodsPOv4FileData } from './smash-foods-purchase-order.js'
import { SnackwiseInvoiceFileData } from './snackwise-invoice.js'
import { SnackwisePickTicketFileData } from './snackwise-pick-ticket.js'
import { SosBudgetFileData } from './sos-budget.js'
import { SosProposalFileData } from './sos-proposal.js'
import { SourcifyCustomerQuoteApprovalFileData } from './sourcify-customer-quote-approval.js'
import { SourcifyCustomerQuoteDetailsApprovalFileData } from './sourcify-customer-quote-details-approval.js'
import { SourcifyRequestForPricingFileData } from './sourcify-request-for-pricing.js'
import { StlPackingSlipFileData } from './stl-packing-slip.js'
import { StlPurchaseOrderFileData } from './stl-purchase-order.js'
import { SuperhumnImporterSecurityFilingFileData } from './superhumn-importer-security-filing.js'
import { TagwallAccountsPayableAgingXlsxFileData } from './tagwall-accounts-payable-aging-xlsx.js'
import { TagwallAccountsReceivableAgingXlsxFileData } from './tagwall-accounts-receivable-aging-xlsx.js'
import { TagwallBillOfLadingFileData } from './tagwall-bill-of-lading.js'
import { TagwallConfigurableReportXlsxFileData } from './tagwall-configurable-report-xlsx.js'
import { TagwallDeliveryTicketFileData } from './tagwall-delivery-ticket.js'
import { TagwallInvoiceFileData } from './tagwall-invoice.js'
import { TagwallPickTicketFileData } from './tagwall-pick-ticket.js'
import { TagwallPurchaseOrderFileData } from './tagwall-purchase-order.js'
import { TagwallReceivingTicketFileData } from './tagwall-receiving-ticket.js'
import { TersusContainerBarcodeFileData } from './tersus-container-barcode.js'
import { ToomPurchaseOrderProcurementFileData } from './toom-purchase-order-procurement.js'
import { ToomPurchaseOrderProductionFileData } from './toom-purchase-order-production.js'
import { VerveCoffeeCertificateOfAnalysisFileData } from './verve-coffee-certificate-of-analysis.js'
import { VerveCoffeePickTicketFileData } from './verve-coffee-pick-ticket.js'
import { VerveCoffeeRequestForCoffeeFileData } from './verve-coffee-request-for-coffee.js'
import { VerveCoffeeSalesOrderShippingLabelFileData } from './verve-coffee-sales-order-shipping-label.js'
import { VerveCoffeeTransferShippingLabelFileData } from './verve-coffee-transfer-shipping-label.js'
import { WorkOrderFileData } from './work-order.js'

/**
 * Given a generated file mapping like the `purchaseOrderFileMappings`, returns a mapping of the
 * key path to the value. This is used to reset the generated file fields in the database.
 */
export function traverseAndMap(
  /* eslint-disable @typescript-eslint/no-explicit-any */
  obj: any,
  prefix = '',
  result: { [key: string]: any } = {},
  /** eslint-enable @typescript-eslint/no-explicit-any */
): { [key: string]: any } {
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    const newKey = prefix ? `${prefix}:${key}` : key

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      traverseAndMap(value, newKey, result)
    } else if (Array.isArray(value) && value.length > 0) {
      // Only get the first value for arrays since the array type (i.e. items in PO) is only going
      // to be of length 1 in the mapping object
      traverseAndMap(value[0], newKey, result)
    } else {
      result[newKey] = value
    }
  })

  return result
}

export type FileData =
  | AbaReportInspectionFileData
  | ArkFoodsOrderConfirmationFileData
  | ArkFoodsPassingSheetFileData
  | ArkFoodsBillOfLadingFileData
  | ArkFoodsInvoiceFileData
  | ArkFoodsPurchaseOrderFileData
  | ArkFoodsQcInspectionFileData
  | ArkFoodsTraderJoesPackingSlipFileData
  | AthenaClubBomExportXlsxFileData
  | AthenaClubCoManEomInventoryReconciliationXlsxFileData
  | AthenaClubPurchaseOrderFileData
  | BalanceSheetFileData
  | BalanceSheetSinglePeriodXlsxFileData
  | BillingStatementFileData
  | BiomGenericGs1128LabelFileData
  | BiomGenericPackingListFileData
  | BiomGroveCasePackLabelFileData
  | BiomGroveMultiSkuPalletLabelFileData
  | BiomGroveOneSkuPalletLabelFileData
  | BiomGrovePackingListFileData
  | BiomTargetPackingListFileData
  | BiomThrivePackingListFileData
  | BiomUnfiPackingListFileData
  | BiomUnfiPalletPlacardFileData
  | BiomVicsBillOfLadingFileData
  | BiomVicsMasterBillOfLadingFileData
  | BiomWarehouseAddressLabelFileData
  | BiomWarehousePickingSlipFileData
  | BNZBriefingFileData
  | BNZEmployeeSafetyFileData
  | BNZProjectSubmissionFileData
  | BNZWorkDiaryFileData
  | CaulipuffsCopackPurchaseOrderFileData
  | CaulipuffsInvoiceFileData
  | CommercialInvoiceFileData
  | CreditMemoFileData
  | CsvFileOutputData
  | DeSoiProductInformationWorksheetCanXlsxFileData
  | DenimTearsPurchaseOrderFileData
  | DenimTearsPurchaseOrderV2FileData
  | DeSoiPurchaseOrderFileData
  | DiversifiedBotanicalsPOFileData
  | DiversifiedBotanicalsSalesOrderFileData
  | DiversifiedBotanicalsInventoryLabelFileData
  | DnbPOFileData
  | EightSleepPOFileData
  | FactorFormPurchaseOrderFileData
  | EightSleepPORmbFileData
  | EightSleepPOBilingualFileData
  | IHPOFileData
  | GraceFarmsPackingSlipFileData
  | MagicMindPackingSlipFileData
  | MagicMindPurchaseOrderFileData
  | GGPurchaseOrderFileDataXlsx
  | IncomeStatementFileData
  | IncomeStatementXlsxFileData
  | IncomeStatementSinglePeriodXlsxFileData
  | InvoiceFileData
  | K1893FreightQuoteFileData
  | K1893InvoiceFileData
  | K1893InvoiceMeijerFileData
  | K1893InvoiceTjsFileData
  | K1893InvoiceUnfiFileData
  | K1893PalletInstructionsFileData
  | K1893PurchaseOrderFileData
  | K1893PurchaseOrderOVGFileData
  | PalletLabelFileData
  | LittlBeastPurchaseOrderFileData
  | MezclaPurchaseOrderFileData
  | NoodlesComplaintFileData
  | NoodlesCreditNoteFileData
  | NoodlesInvoiceFileData
  | NoodlesMidaboSupplierOrderFileData
  | NoodlesOrderFileData
  | NoodlesQuoteFileData
  | NoodlesSupplierOrderFileData
  | PavoiCommercialInvoiceFileData
  | NoodlesDeliveryNoteFileData
  | PopdartsCommissionInvoiceXlsxFileData
  | PurchaseOrderFileData
  | FirstbasePoImportFileData
  | FirstbaseCpReceiptFileData
  | FirstbaseRequestForQuoteFileData
  | POv2FileData
  | POv3FileData
  | POv4FileData
  | QuoteFileData
  | ReflorPurchaseOrderFileData
  | ReflorWorkOrderFileData
  | RemittanceAdviceFileData
  | SalesOrderFileData
  | SelkirkPurchaseOrderFileData
  | SlMunson1099FormFileData
  | SlMunsonPackingSlipFileData
  | SmashFoodsBlanketPOFileData
  | SmashFoodsPOv4FileData
  | SnackwiseInvoiceFileData
  | SnackwisePickTicketFileData
  | SosBudgetFileData
  | SosProposalFileData
  | SourcifyCustomerQuoteApprovalFileData
  | SourcifyCustomerQuoteDetailsApprovalFileData
  | SourcifyRequestForPricingFileData
  | StlPackingSlipFileData
  | StlPurchaseOrderFileData
  | SuperhumnImporterSecurityFilingFileData
  | TagwallPurchaseOrderFileData
  | TagwallInvoiceFileData
  | TagwallDeliveryTicketFileData
  | TagwallBillOfLadingFileData
  | TagwallPickTicketFileData
  | TagwallReceivingTicketFileData
  | TagwallAccountsPayableAgingXlsxFileData
  | TagwallAccountsReceivableAgingXlsxFileData
  | TagwallConfigurableReportXlsxFileData
  | TersusContainerBarcodeFileData
  | ToomPurchaseOrderProcurementFileData
  | ToomPurchaseOrderProductionFileData
  | VerveCoffeePickTicketFileData
  | VerveCoffeeCertificateOfAnalysisFileData
  | VerveCoffeeRequestForCoffeeFileData
  | VerveCoffeeSalesOrderShippingLabelFileData
  | VerveCoffeeTransferShippingLabelFileData
  | PickTicketFileData
  | WorkOrderFileData

/**
 * Given a type, makes all fields required or nullable, but ensures they are all defined
 */
export type MakeRequiredAndNullable<T> = {
  [P in keyof T]-?: T[P] extends (infer U)[]
    ? MakeRequiredAndNullable<U>[] // Recursively apply to array elements
    : T[P] extends object
      ? MakeRequiredAndNullable<T[P]>
      : NonNullable<T[P]> | null
}

/**
 * Converts a generated file type to a MIME type
 */
export function generatedFileTypeToMimeType(fileType: GeneratedFileType): string {
  switch (fileType) {
    case GeneratedFileType.MEZCLA_PURCHASE_ORDER_V2:
      return 'application/pdf'
    case GeneratedFileType.MEZCLA_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_WAREHOUSE_PICKING_SLIP:
      return 'application/pdf'
    case GeneratedFileType.BIOM_WAREHOUSE_ADDRESS_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GENERIC_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_UNFI_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_THRIVE_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GROVE_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_TARGET_PACKING_LIST:
      return 'application/pdf'
    case GeneratedFileType.BIOM_VICS_MASTER_BILL_OF_LADING:
      return 'application/pdf'
    case GeneratedFileType.BIOM_VICS_BILL_OF_LADING:
      return 'application/pdf'
    case GeneratedFileType.BIOM_UNFI_PALLET_PLACARD:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GENERIC_GS1_128_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GROVE_CASE_PACK_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GROVE_MULTI_SKU_PALLET_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_GROVE_ONE_SKU_PALLET_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_THRIVE_SSCC_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_TARGET_PALLET_SSCC_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_TARGET_CARTON_SSCC_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_LICENSE_PLATE_LABEL:
      return 'application/pdf'
    case GeneratedFileType.BIOM_INVOICE:
      return 'application/pdf'
    case GeneratedFileType.CSV:
    case GeneratedFileType.FIRSTBASE_PO_IMPORT:
    case GeneratedFileType.FIRSTBASE_CP_RECEIPT:
      return 'text/csv;charset=utf-8;'
    case GeneratedFileType.ATHENA_CLUB_BOM_EXPORT_XLSX:
    case GeneratedFileType.ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX:
    case GeneratedFileType.BALANCE_SHEET_SINGLE_PERIOD_XLSX:
    case GeneratedFileType.DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX:
    case GeneratedFileType.GG_PURCHASE_ORDER_XLSX:
    case GeneratedFileType.INCOME_STATEMENT_XLSX:
    case GeneratedFileType.INCOME_STATEMENT_SINGLE_PERIOD_XLSX:
    case GeneratedFileType.TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX:
    case GeneratedFileType.TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX:
    case GeneratedFileType.TAGWALL_CONFIGURABLE_REPORT_XLSX:
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    case GeneratedFileType.ABA_REPORT_INSPECTION:
    case GeneratedFileType.ARK_FOODS_ORDER_CONFIRMATION:
    case GeneratedFileType.ARK_FOODS_PASSING_SHEET:
    case GeneratedFileType.ARK_FOODS_BILL_OF_LADING:
    case GeneratedFileType.ARK_FOODS_INVOICE:
    case GeneratedFileType.ARK_FOODS_PURCHASE_ORDER:
    case GeneratedFileType.ARK_FOODS_QC_INSPECTION:
    case GeneratedFileType.ARK_FOODS_TRADER_JOES_PACKING_SLIP:
    case GeneratedFileType.ATHENA_CLUB_PURCHASE_ORDER:
    case GeneratedFileType.BALANCE_SHEET:
    case GeneratedFileType.BILLING_STATEMENT:
    case GeneratedFileType.BNZ_BRIEFING:
    case GeneratedFileType.BNZ_PROJECT_SUBMISSION:
    case GeneratedFileType.BNZ_WORK_DIARY:
    case GeneratedFileType.BNZ_EMPLOYEE_SAFETY:
    case GeneratedFileType.CAULIPUFFS_COPACK_PURCHASE_ORDER:
    case GeneratedFileType.CAULIPUFFS_INVOICE:
    case GeneratedFileType.COMMERCIAL_INVOICE:
    case GeneratedFileType.CREDIT_MEMO:
    case GeneratedFileType.DENIM_TEARS_PURCHASE_ORDER:
    case GeneratedFileType.DENIM_TEARS_PURCHASE_ORDER_V2:
    case GeneratedFileType.DE_SOI_PURCHASE_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_PURCHASE_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_SALES_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_INVENTORY_LABEL:
    case GeneratedFileType.DNB_PURCHASE_ORDER:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER_RMB:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL:
    case GeneratedFileType.INSTANT_HYDRATION_PURCHASE_ORDER:
    case GeneratedFileType.FACTOR_FORM_PURCHASE_ORDER:
    case GeneratedFileType.FIRSTBASE_PURCHASE_ORDER:
    case GeneratedFileType.FIRSTBASE_REQUEST_FOR_QUOTE:
    case GeneratedFileType.GRACE_FARMS_PACKING_SLIP:
    case GeneratedFileType.MAGIC_MIND_PACKING_SLIP:
    case GeneratedFileType.MAGIC_MIND_PURCHASE_ORDER:
    case GeneratedFileType.INCOME_STATEMENT:
    case GeneratedFileType.INVOICE:
    case GeneratedFileType.K1893_FREIGHT_QUOTE:
    case GeneratedFileType.K1893_INVOICE:
    case GeneratedFileType.K1893_INVOICE_MEIJER:
    case GeneratedFileType.K1893_INVOICE_TJS:
    case GeneratedFileType.K1893_INVOICE_UNFI:
    case GeneratedFileType.K1893_PALLET_INSTRUCTIONS:
    case GeneratedFileType.K1893_PURCHASE_ORDER:
    case GeneratedFileType.K1893_PURCHASE_ORDER_OVG:
    case GeneratedFileType.PALLET_LABEL:
    case GeneratedFileType.LITTLE_BEAST_PURCHASE_ORDER:
    case GeneratedFileType.MEZCLA_PURCHASE_ORDER:
    case GeneratedFileType.NOODLES_COMPLAINT:
    case GeneratedFileType.NOODLES_CREDIT_NOTE:
    case GeneratedFileType.NOODLES_DELIVERY_NOTE:
    case GeneratedFileType.NOODLES_INVOICE:
    case GeneratedFileType.NOODLES_MIDABO_SUPPLIER_ORDER:
    case GeneratedFileType.NOODLES_ORDER:
    case GeneratedFileType.NOODLES_QUOTE:
    case GeneratedFileType.NOODLES_SUPPLIER_ORDER:
    case GeneratedFileType.PAVOI_COMMERCIAL_INVOICE:
    case GeneratedFileType.PICK_TICKET:
    case GeneratedFileType.POPDARTS_COMMISSION_INVOICE_XLSX:
    case GeneratedFileType.REFLOR_PURCHASE_ORDER:
    case GeneratedFileType.REFLOR_WORK_ORDER:
    case GeneratedFileType.PURCHASE_ORDER:
    case GeneratedFileType.PURCHASE_ORDER_V2:
    case GeneratedFileType.PURCHASE_ORDER_V3:
    case GeneratedFileType.PURCHASE_ORDER_V4:
    case GeneratedFileType.QUOTE:
    case GeneratedFileType.REMITTANCE_ADVICE:
    case GeneratedFileType.SALES_ORDER:
    case GeneratedFileType.SELKIRK_PURCHASE_ORDER:
    case GeneratedFileType.SL_MUNSON_1099_FORM:
    case GeneratedFileType.SL_MUNSON_PACKING_SLIP:
    case GeneratedFileType.SMASH_FOODS_PURCHASE_ORDER:
    case GeneratedFileType.SMASH_FOODS_BLANKET_PURCHASE_ORDER:
    case GeneratedFileType.SNACKWISE_INVOICE:
    case GeneratedFileType.SNACKWISE_PICK_TICKET:
    case GeneratedFileType.SOS_BUDGET:
    case GeneratedFileType.SOS_PROPOSAL:
    case GeneratedFileType.SOURCIFY_CUSTOMER_QUOTE_APPROVAL:
    case GeneratedFileType.SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL:
    case GeneratedFileType.SOURCIFY_REQUEST_FOR_PRICING:
    case GeneratedFileType.STL_PACKING_SLIP:
    case GeneratedFileType.STL_PURCHASE_ORDER:
    case GeneratedFileType.SUPERHUMN_IMPORTER_SECURITY_FILING:
    case GeneratedFileType.TAGWALL_BILL_OF_LADING:
    case GeneratedFileType.TAGWALL_DELIVERY_TICKET:
    case GeneratedFileType.TAGWALL_INVOICE:
    case GeneratedFileType.TAGWALL_PICK_TICKET:
    case GeneratedFileType.TAGWALL_PURCHASE_ORDER:
    case GeneratedFileType.TAGWALL_RECEIVING_TICKET:
    case GeneratedFileType.TERSUS_CONTAINER_BARCODE:
    case GeneratedFileType.TOOM_PURCHASE_ORDER_PROCUREMENT:
    case GeneratedFileType.TOOM_PURCHASE_ORDER_PRODUCTION:
    case GeneratedFileType.VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS:
    case GeneratedFileType.VERVE_COFFEE_PICK_TICKET:
    case GeneratedFileType.VERVE_COFFEE_PICK_TICKET_BARCODE:
    case GeneratedFileType.VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT:
    case GeneratedFileType.VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL:
    case GeneratedFileType.VERVE_COFFEE_SUPERSACK_LABEL:
    case GeneratedFileType.VERVE_COFFEE_TRANSFER_SHIPPING_LABEL:
    case GeneratedFileType.WORK_ORDER:
      return 'application/pdf'
  }
}

/**
 * Converts a generated file type to a file extension
 */
export function generatedFileTypeToExtension(fileType: GeneratedFileType): 'csv' | 'xlsx' | 'pdf' {
  switch (fileType) {
    case GeneratedFileType.MEZCLA_PURCHASE_ORDER_V2:
      return 'pdf'
    case GeneratedFileType.MEZCLA_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_WAREHOUSE_PICKING_SLIP:
      return 'pdf'
    case GeneratedFileType.BIOM_WAREHOUSE_ADDRESS_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_GENERIC_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_UNFI_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_THRIVE_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_GROVE_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_TARGET_PACKING_LIST:
      return 'pdf'
    case GeneratedFileType.BIOM_VICS_MASTER_BILL_OF_LADING:
      return 'pdf'
    case GeneratedFileType.BIOM_VICS_BILL_OF_LADING:
      return 'pdf'
    case GeneratedFileType.BIOM_UNFI_PALLET_PLACARD:
      return 'pdf'
    case GeneratedFileType.BIOM_GENERIC_GS1_128_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_GROVE_CASE_PACK_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_GROVE_MULTI_SKU_PALLET_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_GROVE_ONE_SKU_PALLET_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_THRIVE_SSCC_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_TARGET_PALLET_SSCC_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_TARGET_CARTON_SSCC_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_LICENSE_PLATE_LABEL:
      return 'pdf'
    case GeneratedFileType.BIOM_INVOICE:
      return 'pdf'
    case GeneratedFileType.CSV:
    case GeneratedFileType.FIRSTBASE_PO_IMPORT:
    case GeneratedFileType.FIRSTBASE_CP_RECEIPT:
      return 'csv'
    case GeneratedFileType.ATHENA_CLUB_BOM_EXPORT_XLSX:
    case GeneratedFileType.ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX:
    case GeneratedFileType.BALANCE_SHEET_SINGLE_PERIOD_XLSX:
    case GeneratedFileType.DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX:
    case GeneratedFileType.GG_PURCHASE_ORDER_XLSX:
    case GeneratedFileType.INCOME_STATEMENT_XLSX:
    case GeneratedFileType.INCOME_STATEMENT_SINGLE_PERIOD_XLSX:
    case GeneratedFileType.TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX:
    case GeneratedFileType.TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX:
    case GeneratedFileType.TAGWALL_CONFIGURABLE_REPORT_XLSX:
      return 'xlsx'
    case GeneratedFileType.ABA_REPORT_INSPECTION:
    case GeneratedFileType.ARK_FOODS_ORDER_CONFIRMATION:
    case GeneratedFileType.ARK_FOODS_PASSING_SHEET:
    case GeneratedFileType.ARK_FOODS_BILL_OF_LADING:
    case GeneratedFileType.ARK_FOODS_INVOICE:
    case GeneratedFileType.ARK_FOODS_PURCHASE_ORDER:
    case GeneratedFileType.ARK_FOODS_QC_INSPECTION:
    case GeneratedFileType.ARK_FOODS_TRADER_JOES_PACKING_SLIP:
    case GeneratedFileType.ATHENA_CLUB_PURCHASE_ORDER:
    case GeneratedFileType.BALANCE_SHEET:
    case GeneratedFileType.BILLING_STATEMENT:
    case GeneratedFileType.BNZ_BRIEFING:
    case GeneratedFileType.BNZ_PROJECT_SUBMISSION:
    case GeneratedFileType.BNZ_WORK_DIARY:
    case GeneratedFileType.BNZ_EMPLOYEE_SAFETY:
    case GeneratedFileType.CAULIPUFFS_COPACK_PURCHASE_ORDER:
    case GeneratedFileType.CAULIPUFFS_INVOICE:
    case GeneratedFileType.COMMERCIAL_INVOICE:
    case GeneratedFileType.CREDIT_MEMO:
    case GeneratedFileType.DENIM_TEARS_PURCHASE_ORDER:
    case GeneratedFileType.DENIM_TEARS_PURCHASE_ORDER_V2:
    case GeneratedFileType.DE_SOI_PURCHASE_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_PURCHASE_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_SALES_ORDER:
    case GeneratedFileType.DIVERSIFIED_BOTANICALS_INVENTORY_LABEL:
    case GeneratedFileType.DNB_PURCHASE_ORDER:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER:
    case GeneratedFileType.FACTOR_FORM_PURCHASE_ORDER:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER_RMB:
    case GeneratedFileType.EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL:
    case GeneratedFileType.INSTANT_HYDRATION_PURCHASE_ORDER:
    case GeneratedFileType.FIRSTBASE_PURCHASE_ORDER:
    case GeneratedFileType.FIRSTBASE_REQUEST_FOR_QUOTE:
    case GeneratedFileType.GRACE_FARMS_PACKING_SLIP:
    case GeneratedFileType.MAGIC_MIND_PACKING_SLIP:
    case GeneratedFileType.MAGIC_MIND_PURCHASE_ORDER:
    case GeneratedFileType.INCOME_STATEMENT:
    case GeneratedFileType.INVOICE:
    case GeneratedFileType.K1893_FREIGHT_QUOTE:
    case GeneratedFileType.K1893_INVOICE:
    case GeneratedFileType.K1893_INVOICE_MEIJER:
    case GeneratedFileType.K1893_INVOICE_TJS:
    case GeneratedFileType.K1893_INVOICE_UNFI:
    case GeneratedFileType.K1893_PALLET_INSTRUCTIONS:
    case GeneratedFileType.K1893_PURCHASE_ORDER:
    case GeneratedFileType.K1893_PURCHASE_ORDER_OVG:
    case GeneratedFileType.PALLET_LABEL:
    case GeneratedFileType.LITTLE_BEAST_PURCHASE_ORDER:
    case GeneratedFileType.MEZCLA_PURCHASE_ORDER:
    case GeneratedFileType.NOODLES_COMPLAINT:
    case GeneratedFileType.NOODLES_CREDIT_NOTE:
    case GeneratedFileType.NOODLES_DELIVERY_NOTE:
    case GeneratedFileType.NOODLES_INVOICE:
    case GeneratedFileType.NOODLES_MIDABO_SUPPLIER_ORDER:
    case GeneratedFileType.NOODLES_ORDER:
    case GeneratedFileType.NOODLES_QUOTE:
    case GeneratedFileType.NOODLES_SUPPLIER_ORDER:
    case GeneratedFileType.PAVOI_COMMERCIAL_INVOICE:
    case GeneratedFileType.PICK_TICKET:
    case GeneratedFileType.POPDARTS_COMMISSION_INVOICE_XLSX:
    case GeneratedFileType.REFLOR_PURCHASE_ORDER:
    case GeneratedFileType.REFLOR_WORK_ORDER:
    case GeneratedFileType.PURCHASE_ORDER:
    case GeneratedFileType.PURCHASE_ORDER_V2:
    case GeneratedFileType.PURCHASE_ORDER_V3:
    case GeneratedFileType.PURCHASE_ORDER_V4:
    case GeneratedFileType.QUOTE:
    case GeneratedFileType.REMITTANCE_ADVICE:
    case GeneratedFileType.SALES_ORDER:
    case GeneratedFileType.SELKIRK_PURCHASE_ORDER:
    case GeneratedFileType.SL_MUNSON_1099_FORM:
    case GeneratedFileType.SL_MUNSON_PACKING_SLIP:
    case GeneratedFileType.SMASH_FOODS_PURCHASE_ORDER:
    case GeneratedFileType.SMASH_FOODS_BLANKET_PURCHASE_ORDER:
    case GeneratedFileType.SNACKWISE_INVOICE:
    case GeneratedFileType.SNACKWISE_PICK_TICKET:
    case GeneratedFileType.SOS_BUDGET:
    case GeneratedFileType.SOS_PROPOSAL:
    case GeneratedFileType.SOURCIFY_CUSTOMER_QUOTE_APPROVAL:
    case GeneratedFileType.SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL:
    case GeneratedFileType.SOURCIFY_REQUEST_FOR_PRICING:
    case GeneratedFileType.STL_PACKING_SLIP:
    case GeneratedFileType.STL_PURCHASE_ORDER:
    case GeneratedFileType.SUPERHUMN_IMPORTER_SECURITY_FILING:
    case GeneratedFileType.TAGWALL_PURCHASE_ORDER:
    case GeneratedFileType.TAGWALL_INVOICE:
    case GeneratedFileType.TAGWALL_DELIVERY_TICKET:
    case GeneratedFileType.TAGWALL_BILL_OF_LADING:
    case GeneratedFileType.TAGWALL_PICK_TICKET:
    case GeneratedFileType.TAGWALL_RECEIVING_TICKET:
    case GeneratedFileType.TERSUS_CONTAINER_BARCODE:
    case GeneratedFileType.TOOM_PURCHASE_ORDER_PROCUREMENT:
    case GeneratedFileType.TOOM_PURCHASE_ORDER_PRODUCTION:
    case GeneratedFileType.VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS:
    case GeneratedFileType.VERVE_COFFEE_PICK_TICKET:
    case GeneratedFileType.VERVE_COFFEE_PICK_TICKET_BARCODE:
    case GeneratedFileType.VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT:
    case GeneratedFileType.VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL:
    case GeneratedFileType.VERVE_COFFEE_SUPERSACK_LABEL:
    case GeneratedFileType.VERVE_COFFEE_TRANSFER_SHIPPING_LABEL:
    case GeneratedFileType.WORK_ORDER:
      return 'pdf'
  }
}
